<div class="wrapper">
    <div class="col">
      <label *ngIf="labelName" class="m-0 p-0" for="validationCustom01">{{labelName}}</label>
      <div ngbDropdown  #dropdown="ngbDropdown" class="d-inline-block w-100" (openChange)="clearSearch()">
        <button type="button" class="btn text-truncate w-100 selected" [id]="id" ngbDropdownToggle>
          {{selectedOption || dropdownLabel || 'Select'}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="option-div p-1">
          <div  class="search-option d-flex justify-content-center">
            <input placeholder="Search" class="search-input p-0" type="text" [(ngModel)]="searchInput" (ngModelChange)="filterOptions()" >
          </div>
          <button class="options p-1" ngbDropdownItem  *ngFor="let option of filteredOptions; let i = index" [id]="option.id" [class.highlighted]="i == highlightedIndex" (click)="selectOption(option)">
            <ng-container *ngIf="selectedId==option.id">
              <svg class="me-1 right-svg" xmlns="http://www.w3.org/2000/svg" width="9.006" height="5.573" viewBox="0 0 9.006 5.573">
                <path id="Path_3416" data-name="Path 3416" d="M6.2,5.875l2.1,3.077L13.8,4.581" transform="translate(-5.501 -3.879)" fill="none" stroke="#383838" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              </svg>
            </ng-container>
            {{option.name}}
          </button>
        </div>
      </div>
    </div>
</div> 


